import {pxToEm} from "utils/styles/style_helpers";


export default theme =>({
    controls:{
        display: 'flex',
        width: 'fit-content',
        borderRadius: `${pxToEm(5)}`,
        boxShadow: theme.boxShadow.small
    }
})